import { useSelectedButtonColor } from 'src/publisher/shared/hooks/use-theme-color/use-selected-button-color'
import { ButtonUiInterface } from 'src/shared/components/button/button-ui.schema'
import { BackgroundEntityInterface } from 'src/shared/schemas/background.schema'
import { BackgroundColorEntityInterface } from 'src/shared/schemas/background-color.schema'
import { WebsiteButtonTypes } from 'src/shared/types/website-settings-types'

export interface UseCalculateButtonThemeColorsProps
  extends Pick<ButtonUiInterface, 'textColor' | 'mobileTextColor'>,
    BackgroundColorEntityInterface,
    BackgroundEntityInterface {
  buttonType: WebsiteButtonTypes
}

export const useCalculateButtonThemeColors = ({
  textColor,
  mobileTextColor,
  background,
  mobileBackground,
  backgroundColor,
  mobileBackgroundColor,
  buttonType,
}: UseCalculateButtonThemeColorsProps) => {
  const { buttonTextColor, buttonBackgroundColor } =
    useSelectedButtonColor(buttonType)

  return {
    calculatedTextColor: {
      desktop: textColor || buttonTextColor,
      mobile: mobileTextColor || buttonTextColor,
    },
    calculatedBackground: {
      desktop: (background ?? backgroundColor) || buttonBackgroundColor,
      mobile:
        (mobileBackground ?? mobileBackgroundColor) || buttonBackgroundColor,
    },
  }
}
